import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-joint-info',
  templateUrl: './joint-info.component.html',
  styleUrls: ['./joint-info.component.scss']
})
export class JointInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
